export default __webpack_public_path__ + "static/media/present_top.b48e80cc.png";